import { useLocation } from '@tanstack/react-router';

import { Header } from '@/components/layout/header';
import { ShellSidebarProvider } from '@/components/layout/shell-sidebar-context';
import { Sidebar } from '@/components/layout/sidebar';

export const MainLayout = ({
  children,
  showSidebar = true,
}: {
  children: React.ReactNode;
  showSidebar?: boolean;
}) => {
  const location = useLocation();

  return (
    <ShellSidebarProvider>
      {/* "relative" stays: the analytics print overlay is positioned against this root */}
      <div className="relative flex h-screen w-full flex-col overflow-hidden">
        <Header />
        <div className="flex w-full flex-1 overflow-hidden">
          {showSidebar ? <Sidebar /> : null}
          {/* "flex flex-col" is kept from the old shell: pages rely on it for flex-1 and h-full children */}
          <main
            data-scroll-container
            key={location.pathname}
            className="flex min-w-0 flex-1 flex-col overflow-x-auto overflow-y-auto p-4 md:p-6"
          >
            {children}
          </main>
        </div>
      </div>
    </ShellSidebarProvider>
  );
};
